var lock = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-int/lock_ld.jpg';
var zipper = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-int/zipper_ld.jpg';
var zipper_g = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-int/zipper_g.jpg';
var intersection = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-int/intersection_ld.jpg';
var crossing = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-int/crossing_g.jpg';
var torque = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-int/torque_ld.jpg';
var closure = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-int/closure_g.jpg';
var mesh = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-int/mesh_ld.jpg';
var mesh_g = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/paper-int/mesh_g.jpg';

export const allImagesDesktopOrderPaperInt = [
    [/*COLUMN 1*/
        [
            {
                name: lock,
                artistName: "Lorraine Shemesh",
                title: "Lock",
                year: "2009",
                dimensions: "8 x 11 in., litho crayon on vellum",
                link: "paperint1",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: zipper,
                artistName: "Lorraine Shemesh",
                title: "Zipper",
                year: "2008",
                dimensions: "13 3/4 x 9 1/2 in., litho crayon on vellum",
                link: "paperint2",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: zipper_g,
                artistName: "Lorraine Shemesh",
                title: "Zipper",
                year: "2008",
                dimensions: "11 x 7 in., gouache on paper",
                link: "paperint3",
                privateCollection: ""
            }
        ]
    ],
    [/*COLUMN 2*/
        [
            {    
                name: intersection,
                artistName: "Lorraine Shemesh",
                title: "Intersection",
                year: "2007",
                dimensions: "10 x 7 1/2 in., marker on vellum",
                link: "paperint4",
                privateCollection: ""
            }
        ],
        [
            {
                name: crossing,
                artistName: "Lorraine Shemesh",
                title: "Crossing",
                year: "2008",
                dimensions: "6 x 4 1/2 in., gouache on paper",
                link: "paperint5",
                privateCollection: ""
            }
        ],
        [
            {
                name: torque,
                artistName: "Lorraine Shemesh",
                title: "Torque",
                year: "2008",
                dimensions: "16  x 11 in., litho crayon on vellum",
                link: "paperint6",
                privateCollection: "Private Collection"
            }
        ]
    ],
    [/*COLUMN 3*/
        [
            {
                name: closure,
                artistName: "Lorraine Shemesh",
                title: "Closure",
                year: "2007",
                dimensions: "7 1/2 x 6 in., gouache on paper",
                link: "paperint7",
                privateCollection: "Private Collection"
            }
        ],
        [
            {
                name: mesh,
                artistName: "Lorraine Shemesh",
                title: "Mesh",
                year: "2008",
                dimensions: "10 x 7 in., marker on vellum",
                link: "paperint8",
                privateCollection: ""
            }
        ],
        [
            {
                name: mesh_g,
                artistName: "Lorraine Shemesh",
                title: "Mesh",
                year: "2008",
                dimensions: "7 3/4 x 4 1/4 in., gouache on paper",
                link: "paperint9",
                privateCollection: ""
            }
        ]
    ]          
]

export const allImagesMobileOrderPaperInt = [
    [{
        name: lock,
        artistName: "Lorraine Shemesh",
        title: "Lock",
        year: "2009",
        dimensions: "8 x 11 in., litho crayon on vellum",
        link: "paperint1",
        privateCollection: "Private Collection"
    },
    {
        name: zipper,
        artistName: "Lorraine Shemesh",
        title: "Zipper",
        year: "2008",
        dimensions: "13 3/4 x 9 1/2 in., litho crayon on vellum",
        link: "paperint2",
        privateCollection: "Private Collection"
    },
    {
        name: zipper_g,
        artistName: "Lorraine Shemesh",
        title: "Zipper",
        year: "2008",
        dimensions: "11 x 7 in., gouache on paper",
        link: "paperint3",
        privateCollection: ""
    },
    {
        name: intersection,
        artistName: "Lorraine Shemesh",
        title: "Intersection",
        year: "2007",
        dimensions: "10 x 7 1/2 in., marker on vellum",
        link: "paperint4",
        privateCollection: ""
    },
    {
        name: crossing,
        artistName: "Lorraine Shemesh",
        title: "Crossing",
        year: "2008",
        dimensions: "6 x 4 1/2 in., gouache on paper",
        link: "paperint5",
        privateCollection: ""
    },
    {
        name: torque,
        artistName: "Lorraine Shemesh",
        title: "Torque",
        year: "2008",
        dimensions: "16  x 11 in., litho crayon on vellum",
        link: "paperint6",
        privateCollection: "Private Collection"
    },
    {
        name: closure,
        artistName: "Lorraine Shemesh",
        title: "Closure",
        year: "2007",
        dimensions: "7 1/2 x 6 in., gouache on paper",
        link: "paperint7",
        privateCollection: "Private Collection"
    },
    {
        name: mesh,
        artistName: "Lorraine Shemesh",
        title: "Mesh",
        year: "2008",
        dimensions: "10 x 7 in., marker on vellum",
        link: "paperint8",
        privateCollection: ""
    },
    {
        name: mesh_g,
        artistName: "Lorraine Shemesh",
        title: "Mesh",
        year: "2008",
        dimensions: "7 3/4 x 4 1/4 in., gouache on paper",
        link: "paperint9",
        privateCollection: ""
    }]      
]
